import { HeaderModalOptions, TRIGGER_MODAL_OPEN_MAP } from 'coreOld/constants';

export const getOpenModalByTriggerParam = (trigger: string): HeaderModalOptions =>
  Object.values(HeaderModalOptions).find((option) => TRIGGER_MODAL_OPEN_MAP[option] === trigger);
